import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_heartland_event.js";
//#region src/bite_log_heartland_event_helper.ts
var bite_log_heartland_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 0: return "ok";
		case 1: return "terminal-disconnected";
		case 2: return "update-idle-text-error";
		case 4: return "refund-error";
		case 5: return "transaction-authorization";
		case 6: return "transaction-authorization-error";
		case 7: return "transaction-sale";
		case 8: return "transaction-sale-error";
		case 9: return "balance-inquiry";
		case 10: return "balance-inquiry-error";
		case 11: return "terminal-connected";
		case 12: return "terminal-init-failed";
		case 13: return "setup-device";
		case 14: return "device-reset-failed";
		case 15: return "native-transaction";
		case 16: return "native-transaction-error";
		case 17: return "transaction-lookup";
		case 18: return "transaction-lookup-error";
	}
}
//#endregion
export { bite_log_heartland_event_helper_exports, name };

//# sourceMappingURL=bite_log_heartland_event_helper.js.map